import { Injectable } from '@angular/core';
import { urls } from './../../../../../environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class CriarSenhaService {

  constructor(private http: HttpClient ) { }

  criarSenha(data) {
    return this.http
      .put(`${urls.apiBaseActuar}/Contas/CriarSenha`, data);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/auth/criar-senha/criar-senha.service.ts